// Vue
import Vue from 'vue'
import Router from 'vue-router'
// 3rd party
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import axios from 'axios'
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/material_blue.css'
import Loading from 'vue-loading-overlay'
import Simplert from 'vue2-simplert-plugin'
import VueAxios from 'vue-axios'
import VueCharts from 'vue-chartjs'
import VueClipboard from 'vue-clipboard2'
import VueFormWizard from 'vue-form-wizard'
import VueGoodTable from 'vue-good-table'
import VueHighlightJS from 'vue-highlightjs'
import VueSlideoutPanel from 'vue-slideout-panel'
require('vue2-simplert-plugin/dist/vue2-simplert-plugin.css')
//
import AppLogs from '@/pages/AppLogs'
import Apps from '@/pages/Apps'
import AppView from '@/pages/AppView'
import Config from '@/pages/Config'
import Deployments from '@/pages/Deployments'
import HeliumDevLatestCLI from '@/pages/HeliumDevLatestCLI'
import Home from '@/pages/Home'
import PgStats from '@/pages/PgStats'
import ScheduledFunctions from '@/pages/ScheduledFunctions'
import SchemaAccess from '@/pages/SchemaAccess'
import SignIn from '@/pages/SignIn'
import SupportRoster from '@/pages/SupportRoster'
import Sync from '@/pages/Sync'
import SyncDashboard from '@/pages/SyncDashboard'
import SyncForm from '@/pages/SyncForm'
import SyncGuide from '@/pages/SyncGuide'
//
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(FlatPickr)
Vue.use(Loading)
Vue.use(Simplert)
Vue.use(VueCharts)
Vue.use(VueClipboard)
Vue.use(VueFormWizard)
Vue.use(VueGoodTable)
Vue.use(VueHighlightJS)
Vue.use(VueSlideoutPanel)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      component: Home
    },
    {
      path: '/home/',
      name: 'home',
      component: Home
    },
    {
      path: '/signin/',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/app/',
      name: 'AppView',
      component: AppView
    },
    {
      path: '/apps/',
      name: 'Apps',
      component: Apps
    },
    {
      path: '/apps/:appid',
      name: 'AppsParam',
      component: Apps
    },
    {
      path: '/logs/:appid',
      name: 'Logs',
      component: AppLogs
    },
    {
      path: '/schema-access/',
      name: 'SchemaAccess',
      component: SchemaAccess
    },
    {
      path: '/deployments/',
      name: 'Deployments',
      component: Deployments
    },
    {
      path: '/config/:appid',
      name: 'Config',
      component: Config
    },
    {
      path: '/scheduledfunctions/:appid',
      name: 'ScheduledFunctions',
      component: ScheduledFunctions
    },
    {
      path: '/support-roster/:team?',
      name: 'SupportRoster',
      component: SupportRoster
    },
    {
      path: '/sync/:appid?',
      name: 'Sync',
      component: Sync
    },
    {
      path: '/sync-guide',
      name: 'SyncGuide',
      component: SyncGuide
    },
    {
      path: '/sync/form/:appid?',
      name: 'SyncForm',
      component: SyncForm
    },
    {
      path: '/sync-dashboard/:name?',
      name: 'SyncDashboard',
      component: SyncDashboard
    },
    {
      path: '/dbspy/:appid?',
      name: 'PgStats',
      component: PgStats
    },
    {
      path: '/helium-dev-latest',
      name: 'HeliumDevLatestCLI',
      component: HeliumDevLatestCLI
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js